module.exports = __webpack_public_path__ + "img/jy.3a500563.png";